export const BUTTON_HIERARCHY = ['btn', 'btn-outline', 'tonal', 'btn-link'] as const;

export interface StorageContentBlockProps {
  node: {
    title?: string;
    subtitle?: string;
    body?: {
      format?: string;
      processed?: string;
    };
    links?: LinkProps[];
    behaviors?: EntityTypeBehaviors;
  };
  richTextSize?: 'small' | 'medium' | 'large';
  className?: string;
  actionCallback?: (link: LinkProps, index: number) => void;
}
